import gql from "graphql-tag";

export default gql`
    mutation RedeemPoints($input: PointsLedgerRedeemInput!) {
        pointsLedgerRedeem(input: $input) {
            uuid
        }
    }
`;